<template>
    <div class="problem-answer">
        <navbar :transparent="isTransparent" activeTo="Services"></navbar>
        <div class="problem-solve">
            <h3>Q: {{problem_answer.title}}</h3>
            <div class="answer-content">
                A: <span v-html="problem_answer.content"></span>
            </div>
        </div>
        <div class="like_problem">
            <h3>{{$t('consultation_Questions')}}</h3>
            <a v-for="(item,index) in likeProblem" :key="index">
                <router-link  :to="{name:'problemContent',params:{id:item.id}}" class="like_problem_title">
                    {{index+1}}. {{item.title}}
                </router-link>
            </a>
        </div>
    </div>
</template>
<script>
    import Signature from '../../lib/Signature'
    import navbar from '../Common/Navbar.vue'
    export default {
        data () {
            return {
                problem_id: 0,
                isTransparent:false,
                problem_answer: {},
                likeProblem:{}
            }
        },
        components:{
            navbar
        },
        watch: {
            '$route': 'fetchData'
        },
        created () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                let self = this
                const module = 'answer'
                let data = {}
                data.problem_id = this.$route.params.id
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.get(process.env.BASEURL + module, {params: data}).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000 ) {
                        console.log(resp.data.data)
                        self.problem_answer = resp.data.data.now_problem
                        self.likeProblem = resp.data.data.similar_problem
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .problem-answer {
        .problem-solve{
            padding: 60px 10px;
            max-width:1240px;
            border-bottom:2px solid #eee;
            margin:0 auto;
            & > h3 {
                    font-size: 24px;
                    text-align: left;
                    margin: 20px 0;
                }
            .answer-content,.answer-content span{
                display: inline-block;
                line-height: 2;
                margin: 20px 0;
                margin: 0 auto;
                font-size: 24px;
                text-align: left;
            }
        }
        .like_problem{
            max-width:1240px;
            margin:0 auto;
            padding:0 10px 10% 10px;
            text-align: left;
            & > h3 {
                    font-size: 24px;
                    margin: 20px 0;
            }
            & > a {
                    /*font-family: PingFangSC-Regular;*/
                    font-size: 16px;
                    color: #1F2D3D;
                    margin: 5px 0;
                    display: block;
            }
            .like_problem_title{
                    color: #1F2D3D;
            }
            .like_problem_title:hover{
                    color: #0084FF;
            }

        }
        @media screen and (max-width: 414px) {
            .problem-solve{

                & > h3 {
                        font-size: 24px;
                        text-align: left;
                        margin: 20px 0;
                    }
                .answer-content{
                    font-size: 16px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ProblemContent.vue?6f11daf6